import { Link as RrdLink } from "react-router-dom"

function Link({ href, ...args }) {
  return <RrdLink {...args} to={href} />
}

export default Link
